import {
	FormControl,
	FormControlLabel,
	Radio,
	RadioGroup,
	Table,
	TableCell,
	TableContainer,
	TableRow,
	Typography,
} from '@mui/material';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import { getScripts } from 'redux/reducers/errorCorrections/selectors';
import { COLORS } from 'services/constants/colors';
import { TStep1Props } from './types';

export const Step1: FC<TStep1Props> = ({ selectedScript, handleScriptChange }) => {
	const scripts = useSelector(getScripts);

	return (
		<FormControl>
			<RadioGroup value={selectedScript} onChange={(e) => handleScriptChange(+e.target.value)}>
				{scripts?.map((script, index) => (
					<FormControlLabel
						key={script.id}
						value={index}
						control={<Radio />}
						label={
							<Typography
								component="div"
								sx={{
									borderRadius: '20px',
									padding: '5px 10px',
									backgroundColor: COLORS.PRIMARY,
									color: COLORS.PAPER,
									display: 'inline-block',
									m: '4px',
									fontSize: '0.9rem',
									opacity: 0.6,
									width: 'fit-content',
									whiteSpace: 'nowrap',
								}}
							>
								{script.name}
							</Typography>
						}
						sx={{ m: 0.4 }}
					/>
				))}
			</RadioGroup>
		</FormControl>
		// 			 <Notice
		// 				text="Integration is now available only for the WIX platform.
		// Integration for other platforms will be available soon"
		// 			/>
		// </Box>
	);
};
